import styled from 'styled-components';
import { Link as CommonLink } from 'react-router-dom';

import { header } from '@rewardopl/styles/z-index';

import { Avatar } from '../../common/avatar.styles';
import { Wrapper as VendorLogo } from '../../common/vendor_logo.styles';

export const Wrapper = styled.header`
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  padding-top: calc(10px + env(safe-area-inset-top));
  padding-right: max(12px, env(safe-area-inset-right));
  z-index: ${header};
  gap: var(--gap);

  @media screen and (min-width: 769px) {
    justify-content: flex-end;
    padding-left: var(--gap);
    padding-right: max(var(--gap), env(safe-area-inset-right));

    ${VendorLogo} {
      display: none;
    }
  }
`;

export const Link = styled(CommonLink)`
  border-radius: var(--border-radius-round);
  line-height: 0;

  ${Avatar} {
    border: 0;
  }
`;
